import LoginStorage from "@/libs/Login";
import constants from "@/libs/Constants";
import DssMapView from '@/views/Simulation/App.vue'
import Privacy from '@/views/Privacy.vue';
import Terms from "@/views/Terms.vue";
import Landing from "@/views/Landing.vue";
import Visualization from '@/views/Visualization/App.vue';
import {createRouter, createWebHashHistory} from 'vue-router';
import {checkUndefinedOrDefaultValue, flagRegisteredEmail} from '@/libs/Helpers';


/**
 * Check if e-mail is registered or move to the landing page
 * @param next
 */
function checkRegisteredEmail(next) {
    if (flagRegisteredEmail() === true && LoginStorage.emailRegistered === null) {
        //No e-mail registered, go back to landing page
        next({name: constants.ROUTING.LANDING})
    } else {
        //Continue
        next()
    }
}

const routes = [
    {
        path: checkUndefinedOrDefaultValue(process.env.VUE_APP_ROUTING_PATH_LANDING, '/'),
        name: constants.ROUTING.LANDING,
        component: Landing
    },
    {
        path: checkUndefinedOrDefaultValue(process.env.VUE_APP_ROUTING_PATH_VISUALIZATION, '/exploration'),
        name: constants.ROUTING.VISUALIZATION,
        component: Visualization,
        beforeEnter: (to, from, next) => {
            checkRegisteredEmail(next);
        }
    },
    {
        path: checkUndefinedOrDefaultValue(process.env.VUE_APP_ROUTING_PATH_DSS_VALLE, '/simulation'),
        name: constants.ROUTING.SIMULATION,
        component: DssMapView,
        beforeEnter: (to, from, next) => {
            checkRegisteredEmail(next);
        }
    },
    {
        path: checkUndefinedOrDefaultValue(process.env.VUE_APP_ROUTING_PATH_PRIVACY, '/privacy'),
        name: constants.ROUTING.PRIVACY,
        component: Privacy
    },
    {
        path: checkUndefinedOrDefaultValue(process.env.VUE_APP_ROUTING_PATH_TERMS, '/terms-of-service'),
        name: constants.ROUTING.TERMS,
        component: Terms
    },
    {
        path: '/:err(.*)*',
        redirect: {name: constants.ROUTING.LANDING}
    }
];

const router = createRouter({
    history: createWebHashHistory(process.env.PUBLIC_PATH !== '' ? process.env.PUBLIC_PATH : '/'),
    routes
});

export default router;